export default __webpack_public_path__ + "static/media/spin-bg-1.194c164a.png";